/* WISH — Bulk & Events builder.
   Data comes from #wish-bulk-data (snippets/wish-bulk.liquid). Tier prices here mirror the automatic discounts
   configured in Shopify on the hidden Bulk products; keep them in sync via the config in the snippet.

   Everything is built from "configurations" (one clear combination of options + a quantity of at least 5):
   - Full-Size Collection   -> state.full.colls
   - Full-Size Personalized -> state.full.configs
   - Mini Favors            -> state.mini.configs
   Each configuration becomes its own cart line, so fulfillment never has to guess which options belong together. */
(function () {
  'use strict';

  var dataEl = document.getElementById('wish-bulk-data');
  var root = document.querySelector('[data-wb]');
  if (!dataEl || !root) return;

  var D = JSON.parse(dataEl.textContent);
  var C = D.config;
  var MIN = C.minPerOption;

  var fmt;
  try {
    fmt = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: D.currency, currencyDisplay: 'narrowSymbol' });
  } catch (e) {
    fmt = { format: function (n) { return '$' + n.toFixed(2); } };
  }
  function money(cents) { return fmt.format(cents / 100); }
  function moneyShort(cents) { return cents % 100 === 0 ? '$' + (cents / 100) : money(cents); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------------- state ---------------- */
  function newConfig() {
    return { moment: '', size: 'small', color: '', scent: '', decor: false, wick: '', qty: 0,
      personalize: false, labelMode: 'same', labelText: '', labelLines: '', notes: '',
      hidden: false, hiddenMode: 'same', hiddenText: '', hiddenLines: '', gift: false };
  }
  function newMini() { return { shape: '', scented: '', scent: '', color: '', pack: '', qty: 0 }; }
  var state = {
    mode: '',
    full: { type: '', colls: [newConfig()], configs: [newConfig()] },
    mini: { type: '', configs: [newMini()], pers: 'no', persNames: '', persDate: '', persMessage: '', persNotes: '' },
    event: { occasion: '', other: '', date: '' },
    custom: { on: false, text: '', email: '', phone: '' }
  };
  var files = {};
  var LIST = { collection: 'colls', personalized: 'configs' };
  var FILEPFX = { collection: 'col', personalized: 'cfg' };

  function getPath(obj, path) {
    var ks = path.split('|'), o = obj;
    for (var i = 0; i < ks.length; i++) { if (o == null) return undefined; o = o[ks[i]]; }
    return o;
  }
  function setPath(obj, path, val) {
    var ks = path.split('|'), o = obj;
    for (var i = 0; i < ks.length - 1; i++) { if (o[ks[i]] == null || typeof o[ks[i]] !== 'object') o[ks[i]] = {}; o = o[ks[i]]; }
    o[ks[ks.length - 1]] = val;
  }
  function num(v) { return parseInt(v, 10) || 0; }

  /* ---------------- pricing ---------------- */
  function fullTier(total) {
    var t = null;
    C.fullTiers.forEach(function (r) { if (total >= r[0]) t = { min: r[0], off: r[1] }; });
    return t;
  }
  function nextFullTier(total) {
    for (var i = 0; i < C.fullTiers.length; i++) if (total < C.fullTiers[i][0]) return { min: C.fullTiers[i][0], off: C.fullTiers[i][1] };
    return null;
  }
  function miniTable() { return state.mini.type === 'tin' ? C.tin : C.threeD; }
  function miniTier(total) {
    var t = null;
    miniTable().forEach(function (r) { if (total >= r[0]) t = { min: r[0], price: r[1] }; });
    return t;
  }
  function nextMiniTier(total) {
    var tb = miniTable();
    for (var i = 0; i < tb.length; i++) if (total < tb[i][0]) return { min: tb[i][0], price: tb[i][1] };
    return null;
  }
  function production(total) {
    var t = Math.max(total, C.production[0].min), row = C.production[0];
    C.production.forEach(function (r) { if (t >= r.min && (r.max == null || t <= r.max)) row = r; });
    return row;
  }
  function lineCount(text) { return (text || '').split(/\r?\n/).map(function (s) { return s.trim(); }).filter(Boolean); }

  /* ---------------- full-size lines ---------------- */
  // Collection and Personalized share the same add-ons: Decor, Hidden Message, Gift Packaging (B&W label + either wick are included).
  // Hidden Message on the Personalized candle is limited to Ivory Natural (same rule as the regular Custom Candle).
  function cfgHiddenAllowed(c, kind) { return kind === 'collection' || c.color === 'Ivory Natural'; }
  function cfgAddons(c, kind) {
    return (c.decor ? D.prices.decor : 0) + (c.hidden && cfgHiddenAllowed(c, kind) ? D.prices.hidden : 0) + (c.gift ? D.prices.gift : 0);
  }
  function sizeLabel(kind, size) { return size === 'small' ? (kind === 'personalized' ? 'Small (4 oz)' : 'Small') : (kind === 'personalized' ? 'Large (10 oz)' : 'Large'); }
  function fullLines() {
    var lines = [];
    state.full.colls.forEach(function (c, i) {
      if (num(c.qty) > 0) lines.push({ kind: 'collection', idx: i, cfg: c, size: c.size, qty: num(c.qty), base: D.prices[c.size === 'small' ? 'colSmall' : 'colLarge'], addon: cfgAddons(c, 'collection'),
        title: 'WISH Moments — ' + (c.moment || 'choose a Moment') + ', ' + sizeLabel('collection', c.size) });
    });
    state.full.configs.forEach(function (c, i) {
      if (num(c.qty) > 0) lines.push({ kind: 'personalized', idx: i, cfg: c, size: c.size, qty: num(c.qty), base: D.prices[c.size === 'small' ? 'perSmall' : 'perLarge'], addon: cfgAddons(c, 'personalized'),
        title: 'Personalized Jar Candle — ' + sizeLabel('personalized', c.size) + (c.color ? ', ' + c.color : '') });
    });
    return lines;
  }
  function fullNeedsMockup(lines) {
    return lines.some(function (l) { return l.cfg.personalize; });
  }
  function textIssues(mode, text, lines, max, label) {
    var out = [];
    if (mode === 'same') { if (!text.trim()) out.push(label + ': please enter the text.'); else if (text.length > max) out.push(label + ' is over ' + max + ' characters.'); }
    else { var ls = lineCount(lines); if (!ls.length) out.push(label + ': please enter at least one line.'); ls.forEach(function (l) { if (l.length > max) out.push(label + ': "' + l.slice(0, 20) + '…" is over ' + max + ' characters.'); }); }
    return out;
  }
  function fullIssues(lines) {
    var issues = [];
    if (!lines.length) { issues.push('Add at least one configuration (minimum ' + MIN + ' candles each).'); return issues; }
    ['collection', 'personalized'].forEach(function (kind) {
      var name = kind === 'collection' ? 'Collection' : 'Personalized';
      state.full[LIST[kind]].forEach(function (cf, i) {
        var n = name + ' configuration ' + (i + 1);
        if (num(cf.qty) === 0) {
          var touched = kind === 'collection' ? (cf.moment || cf.wick) : (cf.color || cf.scent || cf.wick);
          if (touched) issues.push(n + ': set a quantity (minimum ' + MIN + ').');
          return;
        }
        if (kind === 'collection') { if (!cf.moment) issues.push(n + ': choose a Moment.'); }
        else { if (!cf.color) issues.push(n + ': choose a wax color.'); if (!cf.scent) issues.push(n + ': choose a scent.'); }
        if (!cf.wick) issues.push(n + ': choose a wick type.');
        if (cf.personalize) issues = issues.concat(textIssues(cf.labelMode, cf.labelText, cf.labelLines, C.labelMax, n + ' label'));
        if (cf.hidden && cfgHiddenAllowed(cf, kind)) issues = issues.concat(textIssues(cf.hiddenMode, cf.hiddenText, cf.hiddenLines, C.hiddenMax, n + ' hidden message'));
      });
    });
    return issues;
  }

  /* ---------------- mini favors ---------------- */
  function shapeName(id) { var s = D.shapes.filter(function (x) { return x.id === id; })[0]; return s ? s.label : id; }
  function packName(id) { var s = D.packaging.filter(function (x) { return x.id === id; })[0]; return s ? s.label : id; }
  function miniLines() {
    return state.mini.configs.filter(function (c) { return num(c.qty) > 0; });
  }
  function miniTotal() { return state.mini.configs.reduce(function (s, c) { return s + num(c.qty); }, 0); }
  function miniDesc(c) {
    var parts = [];
    if (state.mini.type === 'threeD' && c.shape) parts.push(shapeName(c.shape));
    if (c.color) parts.push(c.color);
    if (c.scented === 'yes' && c.scent) parts.push(c.scent); else if (c.scented === 'no') parts.push('Unscented');
    if (c.pack) parts.push(packName(c.pack));
    return parts.join(' / ') || 'New configuration';
  }
  function miniPersonalized() {
    var m = state.mini;
    return m.pers === 'yes' && !!(m.persNames.trim() || m.persDate.trim() || m.persMessage.trim() || m.persNotes.trim() || files.mini);
  }
  function miniIssues(total) {
    var m = state.mini, issues = [];
    if (!m.type) return ['Choose a favor type.'];
    m.configs.forEach(function (c, i) {
      var n = 'Favor configuration ' + (i + 1);
      if (num(c.qty) === 0) {
        if (c.shape || c.scented || c.color || c.pack) issues.push(n + ': set a quantity (minimum ' + MIN + ').');
        return;
      }
      if (m.type === 'threeD' && !c.shape) issues.push(n + ': choose a shape.');
      if (!c.scented) issues.push(n + ': choose scented or unscented.');
      if (c.scented === 'yes' && !c.scent) issues.push(n + ': choose a scent.');
      if (!c.color) issues.push(n + ': choose a color.');
      if (!c.pack) issues.push(n + ': choose a packaging style.');
    });
    if (total < C.miniMinTotal) issues.push('Minimum order is ' + C.miniMinTotal + ' favors (currently ' + total + ').');
    if (m.pers === 'yes' && !miniPersonalized()) issues.push('Add your personalization details, or choose the standard WISH design.');
    return issues;
  }

  /* ---------------- dates ---------------- */
  function addBusinessDays(d, n) {
    var x = new Date(d.getTime()), left = n;
    while (left > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) left--; }
    return x;
  }
  // Shipping time is only an ESTIMATE (C.shippingEstimateBusinessDays). It is a placeholder until the real
  // estimate from checkout / carrier rates can be used.
  function dateWarning(total, mockup) {
    var v = state.event.date;
    if (!v) return '';
    var parts = v.split('-'); if (parts.length !== 3) return '';
    var ev = new Date(+parts[0], +parts[1] - 1, +parts[2]);
    var prod = production(total || C.production[0].min);
    var days = (mockup ? C.mockupBusinessDays : 0) + prod.hi + (C.shippingEstimateBusinessDays || 5);
    var earliest = addBusinessDays(new Date(), days);
    earliest.setHours(0, 0, 0, 0);
    return ev < earliest ? 'Your event is coming up soon. Based on your order size and estimated production time, arrival before this date may not be guaranteed. Shipping time is an estimate and depends on your delivery address and carrier.' : '';
  }

  /* ---------------- markup helpers ---------------- */
  function stepper(path, min) {
    return '<div class="wb-step" data-step data-min="' + min + '"><button type="button" data-dir="-1" aria-label="Decrease">&minus;</button>' +
      '<input type="number" inputmode="numeric" min="0" value="0" data-path="' + path + '" data-min="' + min + '" aria-label="Quantity"><button type="button" data-dir="1" aria-label="Increase">+</button></div>';
  }
  function radioRow(name, path, options) {
    return options.map(function (o) {
      return '<label class="wb-radio"><input type="radio" name="' + name + '" value="' + esc(o.value) + '" data-path="' + path + '"><span>' + o.label + '</span></label>';
    }).join('');
  }
  function swatchRadios(name, path, items) {
    return '<div class="wb-colors">' + items.map(function (c) {
      return '<label class="wb-color"><input type="radio" name="' + name + '" value="' + esc(c.value) + '" data-path="' + path + '" class="wb-visually-hidden">' + (c.hex ? '<i class="wb-swatch" style="background:' + esc(c.hex) + '"></i>' : '') + '<span>' + esc(c.label) + (c.desc ? '<small>' + esc(c.desc) + '</small>' : '') + '</span></label>';
    }).join('') + '</div>';
  }
  function labelBlock(p, idPrefix, kind) {
    return '<label class="wb-check"><input type="checkbox" data-path="' + p + 'personalize"><span class="wb-check__box" aria-hidden="true"></span><span>Personalize the label <em>(B&amp;W, included)</em></span></label>' +
      '<div class="wb-sub" data-show="' + p + 'personalize=true" hidden>' +
        '<fieldset class="wb-fieldset"><legend>Label text</legend>' + radioRow(idPrefix + '-lm', p + 'labelMode', [{ value: 'same', label: 'Same message on every candle' }, { value: 'lines', label: 'Different names or messages' }]) + '</fieldset>' +
        '<div data-show="' + p + 'labelMode=same" hidden><input class="wb-input" type="text" maxlength="45" data-path="' + p + 'labelText" placeholder="A name, a date, a wish" aria-label="Label message"><p class="wb-hint">Up to 45 characters, including spaces.</p></div>' +
        '<div data-show="' + p + 'labelMode=lines" hidden><textarea class="wb-input" rows="5" data-path="' + p + 'labelLines" aria-label="One name or message per line" placeholder="One name or message per line"></textarea><p class="wb-hint">Up to 45 characters per line. <span data-line-count="' + p + 'labelLines"></span></p></div>' +
        '<label class="wb-label" for="' + idPrefix + '-file">B&amp;W photo or design</label><input class="wb-input" id="' + idPrefix + '-file" type="file" accept="image/png,image/jpeg,image/webp" data-file="' + FILEPFX[kind] + idPrefix.split('-').pop() + '">' +
        '<label class="wb-label" for="' + idPrefix + '-notes">Design ideas or instructions</label><textarea class="wb-input" id="' + idPrefix + '-notes" rows="3" data-path="' + p + 'notes"></textarea>' +
      '</div>';
  }
  function hiddenBlock(p, idPrefix) {
    return '<label class="wb-check"><input type="checkbox" data-path="' + p + 'hidden"><span class="wb-check__box" aria-hidden="true"></span><span>Add a Hidden Message <em>(+' + money(D.prices.hidden) + ' each)</em></span></label>' +
      '<div class="wb-sub" data-show="' + p + 'hidden=true" hidden>' +
        '<fieldset class="wb-fieldset"><legend>Hidden message</legend>' + radioRow(idPrefix + '-hm', p + 'hiddenMode', [{ value: 'same', label: 'Same on every candle' }, { value: 'lines', label: 'Different on each candle' }]) + '</fieldset>' +
        '<div data-show="' + p + 'hiddenMode=same" hidden><input class="wb-input" type="text" maxlength="30" data-path="' + p + 'hiddenText" placeholder="Your hidden message" aria-label="Hidden message"><p class="wb-hint">Up to 30 characters, including spaces.</p></div>' +
        '<div data-show="' + p + 'hiddenMode=lines" hidden><textarea class="wb-input" rows="4" data-path="' + p + 'hiddenLines" aria-label="One hidden message per line" placeholder="One hidden message per line"></textarea><p class="wb-hint">Up to 30 characters per line. <span data-line-count="' + p + 'hiddenLines"></span></p></div>' +
      '</div>';
  }

  // One Full-Size configuration card (Collection or Personalized).
  function configHTML(kind, i) {
    var list = LIST[kind], p = 'full|' + list + '|' + i + '|', id = 'wb-' + kind + '-' + i;
    var multiple = state.full[list].length > 1;
    var head = '<div class="wb-config__head"><h4>Configuration ' + (i + 1) + '</h4>' + (multiple ? '<button type="button" class="wb-link" data-remove-config="' + kind + ':' + i + '">Remove</button>' : '') + '</div>';
    var sizePrices = kind === 'collection' ? [D.prices.colSmall, D.prices.colLarge] : [D.prices.perSmall, D.prices.perLarge];
    var size = '<fieldset class="wb-fieldset"><legend>Size</legend>' + radioRow(id + '-size', p + 'size', [
      { value: 'small', label: sizeLabel(kind, 'small') + ' — ' + money(sizePrices[0]) }, { value: 'large', label: sizeLabel(kind, 'large') + ' — ' + money(sizePrices[1]) }]) + '</fieldset>';
    var base;
    if (kind === 'collection') {
      base = '<label class="wb-label" for="' + id + '-moment">WISH Moment</label><select class="wb-input" id="' + id + '-moment" data-path="' + p + 'moment"><option value=""></option>' +
        D.moments.map(function (m) { return '<option value="' + esc(m.title) + '">' + esc(m.title) + '</option>'; }).join('') + '</select>' +
        '<p class="wb-hint">The Moment is your base design. Everything below is added to it.</p>';
    } else {
      base = '<fieldset class="wb-fieldset"><legend>Wax color</legend>' + swatchRadios(id + '-color', p + 'color', D.colors.map(function (c) { return { value: c.name, label: c.name, hex: c.hex }; })) + '</fieldset>' +
        '<label class="wb-label" for="' + id + '-scent">Scent</label><select class="wb-input" id="' + id + '-scent" data-path="' + p + 'scent"><option value=""></option>' +
        D.scents.map(function (s) { return '<option value="' + esc(s.name) + '">' + esc(s.name) + '</option>'; }).join('') + '</select>';
    }
    var decor = '<label class="wb-check"><input type="checkbox" data-path="' + p + 'decor"><span class="wb-check__box" aria-hidden="true"></span><span>Decor <em>(+' + money(D.prices.decor) + ' each)</em></span></label>';
    var wick = '<fieldset class="wb-fieldset"><legend>Wick type <em class="wb-inc">(no extra charge)</em></legend>' + radioRow(id + '-wick', p + 'wick', [
      { value: 'Cotton Wick', label: 'Cotton Wick <small>Classic, steady burn.</small>' }, { value: 'Wooden Wick', label: 'Wooden Wick <small>Soft crackle as it burns.</small>' }]) + '</fieldset>';
    var qty = '<label class="wb-label">How many candles in this configuration?</label>' + stepper(p + 'qty', MIN);
    var hidden;
    if (kind === 'personalized') {
      hidden = '<div data-show="' + p + 'color=Ivory Natural" hidden>' + hiddenBlock(p, id) + '</div>' +
        '<p class="wb-hint" data-show="' + p + 'color=Ivory Natural" data-show-not hidden>Hidden Message is only available with Ivory Natural.</p>';
    } else {
      hidden = hiddenBlock(p, id);
    }
    var gift = '<label class="wb-check"><input type="checkbox" data-path="' + p + 'gift"><span class="wb-check__box" aria-hidden="true"></span><span>Add Gift Packaging <em>(+' + money(D.prices.gift) + ' each)</em></span></label>';
    return '<div class="wb-config" data-config="' + kind + ':' + i + '">' + head + size + base + decor + wick + qty + labelBlock(p, id, kind) + hidden + gift + '</div>';
  }

  // One Mini Favor configuration card.
  function miniHTML(i) {
    var p = 'mini|configs|' + i + '|', id = 'wb-mini-' + i;
    var multiple = state.mini.configs.length > 1;
    var head = '<div class="wb-config__head"><h4>Favor configuration ' + (i + 1) + '</h4>' + (multiple ? '<button type="button" class="wb-link" data-remove-mini="' + i + '">Remove</button>' : '') + '</div>';
    var shape = '<div data-show="mini|type=threeD" hidden><fieldset class="wb-fieldset"><legend>Shape</legend>' +
      swatchRadios(id + '-shape', p + 'shape', D.shapes.map(function (s) { return { value: s.id, label: s.label }; })) + '</fieldset></div>';
    var scented = '<fieldset class="wb-fieldset"><legend>Scented or unscented <em class="wb-inc">(same price)</em></legend>' + radioRow(id + '-sc', p + 'scented', [{ value: 'yes', label: 'Scented' }, { value: 'no', label: 'Unscented' }]) + '</fieldset>' +
      '<div data-show="' + p + 'scented=yes" hidden><label class="wb-label" for="' + id + '-scent">Scent</label><select class="wb-input" id="' + id + '-scent" data-path="' + p + 'scent"><option value=""></option>' +
      D.scents.map(function (s) { return '<option value="' + esc(s.name) + '">' + esc(s.name) + '</option>'; }).join('') + '</select></div>';
    var color = '<fieldset class="wb-fieldset"><legend>Wax color <em class="wb-inc">(same price)</em></legend>' + swatchRadios(id + '-color', p + 'color', D.colors.map(function (c) { return { value: c.name, label: c.name, hex: c.hex }; })) + '</fieldset>';
    var pack = '<fieldset class="wb-fieldset"><legend>Gift packaging <em class="wb-inc">(included)</em></legend>' + swatchRadios(id + '-pack', p + 'pack', D.packaging.map(function (x) { return { value: x.id, label: x.label, desc: x.desc }; })) + '</fieldset>';
    var qty = '<label class="wb-label">How many favors in this configuration?</label>' + stepper(p + 'qty', MIN);
    return '<div class="wb-config" data-config="mini:' + i + '">' + head + shape + scented + color + pack + qty + '</div>';
  }

  function renderConfigList(kind) {
    var host = root.querySelector('[data-config-list="' + kind + '"]');
    if (!host) return;
    host.innerHTML = state.full[LIST[kind]].map(function (c, i) { return configHTML(kind, i); }).join('');
    syncInputs();
  }
  function renderMiniList() {
    var host = root.querySelector('[data-mini-list]');
    if (!host) return;
    host.innerHTML = state.mini.configs.map(function (c, i) { return miniHTML(i); }).join('');
    syncInputs();
  }

  function mountExtras() {
    var tpl = document.getElementById('wb-tpl-extras');
    root.querySelectorAll('[data-extras-slot]').forEach(function (slot, n) {
      slot.appendChild(tpl.content.cloneNode(true));
      slot.querySelectorAll('[data-id]').forEach(function (el) {
        var id = 'wb-x' + n + '-' + el.getAttribute('data-id');
        el.id = id;
        var lab = slot.querySelector('[data-for="' + el.getAttribute('data-id') + '"]');
        if (lab) lab.setAttribute('for', id);
      });
    });
  }

  /* ---------------- sync + visibility ---------------- */
  function syncInputs() {
    root.querySelectorAll('[data-path]').forEach(function (el) {
      var v = getPath(state, el.getAttribute('data-path'));
      if (el.type === 'checkbox') el.checked = !!v;
      else if (el.type === 'radio') el.checked = (v === el.value);
      else if (document.activeElement !== el) el.value = v == null ? (el.type === 'number' ? 0 : '') : v;
    });
  }
  function evalShow(el) {
    var rules = el.getAttribute('data-show').split(',');
    var any = el.hasAttribute('data-show-any');
    var results = rules.map(function (r) {
      var i = r.indexOf('='); var path = r.slice(0, i), want = r.slice(i + 1);
      var v = getPath(state, path); return String(v == null ? '' : v) === want;
    });
    var ok = any ? results.some(Boolean) : results.every(Boolean);
    if (el.hasAttribute('data-show-not')) ok = !ok;
    return ok;
  }
  function applyVisibility() {
    root.querySelectorAll('[data-show]').forEach(function (el) { el.hidden = !evalShow(el); });
    root.querySelectorAll('[data-card],[data-bigcard]').forEach(function (l) {
      var inp = l.querySelector('input'); l.classList.toggle('is-selected', !!(inp && inp.checked));
    });
  }

  /* ---------------- tier table + summaries ---------------- */
  function pct(off, base) { return Math.round(off / base * 100); }
  function renderTierFull(total) {
    var host = root.querySelector('[data-tier-table="full"]');
    var t = state.full.type;
    if (t !== 'collection' && t !== 'personalized') { host.innerHTML = ''; return; }
    var bs = D.prices[t === 'collection' ? 'colSmall' : 'perSmall'], bl = D.prices[t === 'collection' ? 'colLarge' : 'perLarge'];
    var cur = fullTier(total);
    var cells = C.fullTiers.map(function (r) {
      var active = cur && cur.min === r[0];
      return '<div class="wb-tier' + (active ? ' is-active' : '') + '"><span class="wb-tier__n">' + r[0] + '+</span>' +
        '<span class="wb-tier__save">Save ' + moneyShort(r[1]) + ' each</span>' +
        '<span class="wb-tier__each">Small ' + money(bs - r[1]) + ' <em>' + pct(r[1], bs) + '% off</em></span>' +
        '<span class="wb-tier__each">Large ' + money(bl - r[1]) + ' <em>' + pct(r[1], bl) + '% off</em></span></div>';
    }).join('');
    host.innerHTML = '<h3 class="wb-h3">Bulk savings</h3><p class="wb-note">Regular: Small ' + money(bs) + ' &middot; Large ' + money(bl) + '. The tier is based on the <b>total</b> number of full-size candles in your order (Small + Large, Collection + Personalized).</p><div class="wb-tiergrid">' + cells + '</div>';
  }
  function renderTierMini(total) {
    var host = root.querySelector('[data-tier-table="mini"]');
    if (!state.mini.type) { host.innerHTML = ''; return; }
    var tb = miniTable(), cur = miniTier(total), first = tb[0][1];
    var big = cur ? money(cur.price) : money(first);
    var cells = tb.map(function (r) {
      var active = cur && cur.min === r[0];
      return '<div class="wb-tier' + (active ? ' is-active' : '') + '"><span class="wb-tier__n">' + r[0] + '+</span><span class="wb-tier__each wb-tier__each--big">' + money(r[1]) + ' each</span>' + (r[1] < first ? '<span class="wb-tier__save">Save ' + moneyShort(first - r[1]) + ' each</span>' : '') + '</div>';
    }).join('');
    host.innerHTML = '<div class="wb-pricebig"><span>Price per favor</span><b>' + big + '</b><small>' + (cur ? cur.min + '+ tier' : 'from ' + C.miniMinTotal + ' favors') + '</small></div>' +
      '<p class="wb-note">The price tier is based on the <b>total</b> number of ' + (state.mini.type === 'tin' ? '1 oz tin' : '3D') + ' favors across all your configurations.</p><div class="wb-tiergrid">' + cells + '</div>';
  }

  function prodBlock(total, mockup) {
    var p = production(total);
    return '<p class="wb-prod"><b>Estimated production time: ' + p.lo + '&ndash;' + p.hi + ' business days</b><br>' +
      (mockup ? 'Begins after final design approval. ' : '') + 'Production time doesn&rsquo;t include shipping time.</p>';
  }
  function policyBlock(mockup) {
    var out = '';
    if (mockup) {
      out += '<div class="wb-mockup"><p class="wb-mockup__title">Your design comes next.</p><p>We&rsquo;ll email your custom B&amp;W mockup within 1&ndash;5 business days. Up to 2 revisions are included. Production begins only after you approve your final design.</p>' +
        '<ol class="wb-steps" aria-label="Design process"><li>Place Order</li><li>We Create Your Mockup</li><li>Review &amp; Revise</li><li>Approve</li><li>Production</li></ol>' +
        '<p class="wb-fine">You can cancel any time before you give your final design approval by email. Once you approve, your order is released for production &mdash; personalization can no longer be changed, and the order becomes non-refundable and can&rsquo;t be cancelled.</p></div>';
    } else {
      out += '<p class="wb-fine">This order can be cancelled within 12 hours of purchase. After 12 hours, it&rsquo;s released for production and becomes non-refundable and can&rsquo;t be cancelled.</p>';
    }
    return out;
  }
  function commonTail(total) {
    return '<p class="wb-fine">Shipping calculated at checkout. Bulk &amp; Events orders are paid 100% at checkout and aren&rsquo;t part of the regular free-shipping promotion.</p>' +
      (total >= 100 ? '<p class="wb-assist"><b>Ordering 100+?</b> We&rsquo;re here if you need help with your order. <a href="/pages/contact">Contact Us &rarr;</a></p>' : '');
  }
  function issuesBlock(issues, hasLines) {
    return hasLines && issues.length ? '<ul class="wb-issues">' + issues.slice(0, 5).map(function (s) { return '<li>' + esc(s) + '</li>'; }).join('') + '</ul>' : '';
  }

  function renderFullSummary() {
    var host = root.querySelector('[data-summary="full"]');
    var lines = fullLines();
    var total = lines.reduce(function (s, l) { return s + l.qty; }, 0);
    var tier = fullTier(total), off = tier ? tier.off : 0;
    var mockup = fullNeedsMockup(lines);
    var regular = 0, savings = 0, addons = 0, sub = 0;
    var rows = lines.map(function (l) {
      var each = l.base - off, line = each * l.qty;
      regular += l.base * l.qty; savings += off * l.qty; addons += l.addon * l.qty; sub += line + l.addon * l.qty;
      return '<tr><td>' + esc(l.title) + '</td><td>' + l.qty + '</td><td>' + money(each) + (off ? ' <s>' + money(l.base) + '</s>' : '') + '</td><td>' + money(line) + '</td></tr>';
    }).join('');
    var next = nextFullTier(total), nudge = '';
    if (total > 0 && next) nudge = '<p class="wb-nudge">Add ' + (next.min - total) + ' more full-size candle' + (next.min - total === 1 ? '' : 's') + ' to save ' + moneyShort(next.off) + ' each (' + next.min + '+).</p>';
    var issues = fullIssues(lines);
    host.innerHTML = '<h3 class="wb-h3">Your bulk order</h3>' +
      (lines.length ? '<div class="wb-scroll"><table class="wb-sumtable"><thead><tr><th>Item</th><th>Qty</th><th>Each</th><th>Total</th></tr></thead><tbody>' + rows + '</tbody></table></div>' +
        '<dl class="wb-totals"><div><dt>Candles</dt><dd>' + total + '</dd></div>' +
        '<div><dt>Bulk pricing</dt><dd>' + (tier ? tier.min + '+ &mdash; ' + moneyShort(off) + ' off each' : 'Regular price (savings start at 10+)') + '</dd></div>' +
        '<div><dt>Regular price</dt><dd>' + money(regular) + '</dd></div>' +
        '<div><dt>Bulk savings</dt><dd>' + (savings ? 'You save ' + money(savings) : '—') + '</dd></div>' +
        (addons ? '<div><dt>Add-ons</dt><dd>' + money(addons) + '</dd></div>' : '') +
        '<div class="wb-totals__final"><dt>Order subtotal</dt><dd>' + money(sub) + '</dd></div></dl>' + nudge + prodBlock(total, mockup) + policyBlock(mockup) + commonTail(total) : '<p class="wb-note">Your order summary appears here as you build your configurations.</p>') +
      '<div class="wb-cta">' + issuesBlock(issues, lines.length > 0) +
      '<button type="button" class="wb-btn wb-btn--solid" data-add="full"' + (issues.length ? ' disabled' : '') + '>Add to cart</button><p class="wb-status" data-add-status="full" role="status"></p></div>';
    return { total: total, mockup: mockup };
  }

  function renderMiniSummary() {
    var host = root.querySelector('[data-summary="mini"]');
    var m = state.mini, total = miniTotal(), tier = miniTier(total), mockup = miniPersonalized();
    var first = miniTable()[0][1];
    var each = tier ? tier.price : first;
    var lines = miniLines();
    var rows = lines.map(function (c) { return '<tr><td>' + esc(miniDesc(c)) + '</td><td>' + num(c.qty) + '</td><td>' + money(each) + '</td><td>' + money(each * num(c.qty)) + '</td></tr>'; }).join('');
    var issues = miniIssues(total);
    var next = nextMiniTier(total), nudge = '';
    if (total > 0 && next) nudge = '<p class="wb-nudge">Add ' + (next.min - total) + ' more favor' + (next.min - total === 1 ? '' : 's') + ' to get ' + money(next.price) + ' each (' + next.min + '+).</p>';
    host.innerHTML = '<h3 class="wb-h3">Your favor order</h3>' +
      (total > 0 ? '<div class="wb-scroll"><table class="wb-sumtable"><thead><tr><th>Configuration</th><th>Qty</th><th>Each</th><th>Total</th></tr></thead><tbody>' + rows + '</tbody></table></div>' +
        '<dl class="wb-totals"><div><dt>Favors</dt><dd>' + total + '</dd></div><div><dt>Price per favor</dt><dd>' + money(each) + '</dd></div>' +
        (each < first ? '<div><dt>Savings</dt><dd>You save ' + money((first - each) * total) + ' vs the 10+ price</dd></div>' : '') +
        '<div><dt>Gift packaging</dt><dd>Included</dd></div><div class="wb-totals__final"><dt>Order subtotal</dt><dd>' + money(each * total) + '</dd></div></dl>' + nudge + prodBlock(total, mockup) + policyBlock(mockup) + commonTail(total) :
        '<p class="wb-note">Your order summary appears here as you build your favor configurations.</p>') +
      '<div class="wb-cta">' + issuesBlock(issues, total > 0) +
      '<button type="button" class="wb-btn wb-btn--solid" data-add="mini"' + (issues.length ? ' disabled' : '') + '>Add to cart</button><p class="wb-status" data-add-status="mini" role="status"></p></div>';
    return { total: total, mockup: mockup };
  }

  function update() {
    syncInputs();
    // Hidden Message on the Personalized candle only works with Ivory Natural: clear it if the color changed
    state.full.configs.forEach(function (c) { if (c.hidden && !cfgHiddenAllowed(c, 'personalized')) c.hidden = false; });
    applyVisibility();
    var fs = renderFullSummary(), ms = renderMiniSummary();
    renderTierFull(fs.total);
    renderTierMini(ms.total);
    root.querySelectorAll('[data-line-count]').forEach(function (el) {
      var n = lineCount(getPath(state, el.getAttribute('data-line-count')) || '').length;
      el.textContent = n ? n + ' entered' : '';
    });
    var act = state.mode === 'mini' ? ms : fs;
    var warn = dateWarning(act.total, act.mockup);
    root.querySelectorAll('[data-date-warning]').forEach(function (el) { el.textContent = warn; el.hidden = !warn; });
    syncInputs();
    applyVisibility();
  }

  /* ---------------- events ---------------- */
  var lastMode = '', lastFullType = '', lastMiniType = '';
  function onField(e) {
    var el = e.target;
    if (el.matches && el.matches('[data-file]')) { files[el.getAttribute('data-file')] = el.files && el.files[0] ? el.files[0] : null; update(); return; }
    var path = el.getAttribute && el.getAttribute('data-path');
    if (!path) return;
    var val;
    if (el.type === 'checkbox') val = el.checked;
    else if (el.type === 'radio') { if (!el.checked) return; val = el.value; }
    else if (el.type === 'number') {
      val = num(el.value);
      if (e.type === 'change') { var min = num(el.getAttribute('data-min')) || MIN; if (val > 0 && val < min) val = min; if (val < 0) val = 0; el.value = val; }
    } else val = el.value;
    setPath(state, path, val);
    update();
    if (e.type === 'change') afterChoice();
  }
  function afterChoice() {
    var target = null;
    if (state.mode !== lastMode) { target = document.getElementById(state.mode === 'mini' ? 'wb-mini' : 'wb-full'); }
    else if (state.full.type !== lastFullType && state.full.type) { target = root.querySelector('#wb-full .wb-panel:not([hidden])'); }
    else if (state.mini.type !== lastMiniType && state.mini.type) { target = root.querySelector('#wb-mini .wb-panel:not([hidden])'); }
    lastMode = state.mode; lastFullType = state.full.type; lastMiniType = state.mini.type;
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  function remapFiles(prefix, removed) {
    var nf = {};
    Object.keys(files).forEach(function (k) {
      var m = /^([a-z]+)(\d+)$/.exec(k);
      if (!m || m[1] !== prefix) { nf[k] = files[k]; return; }
      var n = +m[2];
      if (n < removed) nf[k] = files[k]; else if (n > removed) nf[prefix + (n - 1)] = files[k];
    });
    files = nf;
  }
  root.addEventListener('input', onField);
  root.addEventListener('change', onField);
  root.addEventListener('click', function (e) {
    var step = e.target.closest('[data-dir]');
    if (step) {
      var wrap = step.closest('[data-step]'), inp = wrap.querySelector('input');
      var min = num(wrap.getAttribute('data-min')) || MIN, v = num(inp.value), dir = num(step.getAttribute('data-dir'));
      v = dir > 0 ? (v === 0 ? min : v + 1) : (v <= min ? 0 : v - 1);
      inp.value = v; setPath(state, inp.getAttribute('data-path'), v); update(); return;
    }
    var addCfg = e.target.closest('[data-add-config]');
    if (addCfg) { var k = addCfg.getAttribute('data-add-config'); state.full[LIST[k]].push(newConfig()); renderConfigList(k); update(); return; }
    var rmCfg = e.target.closest('[data-remove-config]');
    if (rmCfg) {
      var parts = rmCfg.getAttribute('data-remove-config').split(':'), kind = parts[0], ri = num(parts[1]);
      state.full[LIST[kind]].splice(ri, 1);
      if (!state.full[LIST[kind]].length) state.full[LIST[kind]].push(newConfig());
      remapFiles(FILEPFX[kind], ri); renderConfigList(kind); update(); return;
    }
    if (e.target.closest('[data-add-mini]')) { state.mini.configs.push(newMini()); renderMiniList(); update(); return; }
    var rmMini = e.target.closest('[data-remove-mini]');
    if (rmMini) {
      state.mini.configs.splice(num(rmMini.getAttribute('data-remove-mini')), 1);
      if (!state.mini.configs.length) state.mini.configs.push(newMini());
      renderMiniList(); update(); return;
    }
    var add = e.target.closest('[data-add]');
    if (add && !add.disabled) { addToCart(add.getAttribute('data-add'), add); }
  });

  /* ---------------- add to cart ---------------- */
  function joinLines(text) { return lineCount(text).join(' | '); }
  function attrsBase(kind, total, mockup) {
    var p = production(total);
    var a = {
      'Order type': 'Bulk & Events', 'Bulk category': kind,
      'Requires mockup': mockup ? 'Yes' : 'No',
      'Estimated production': p.lo + '–' + p.hi + ' business days' + (mockup ? ' (after final design approval)' : ''),
      'Cancellation terms': mockup ? 'Cancel any time before final design approval (email). After approval: non-refundable.' : 'Cancel within 12 hours of purchase. After that: non-refundable.',
      'Occasion': state.event.occasion === 'Other' ? ('Other: ' + state.event.other) : state.event.occasion,
      'Event date': state.event.date,
      'Custom request': '', 'Custom request contact': ''
    };
    if (state.custom.on && (state.custom.text.trim() || state.custom.email.trim() || state.custom.phone.trim())) {
      a['Custom request'] = state.custom.text.trim();
      a['Custom request contact'] = [state.custom.email.trim(), state.custom.phone.trim()].filter(Boolean).join(' / ');
    }
    return a;
  }
  function postForm(fd) {
    return fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; });
    });
  }
  function fdFor(id, qty, props, file, fileKey) {
    var fd = new FormData();
    fd.append('id', id); fd.append('quantity', qty);
    Object.keys(props).forEach(function (k) { if (props[k] !== '' && props[k] != null) fd.append('properties[' + k + ']', props[k]); });
    if (file) fd.append('properties[' + fileKey + ']', file);
    return fd;
  }
  function postJSON(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Request failed'); return j; });
    });
  }

  function addToCart(kind, btn) {
    var status = root.querySelector('[data-add-status="' + kind + '"]');
    btn.disabled = true; status.textContent = 'Adding to your cart…'; status.classList.remove('is-error');
    var job = kind === 'full' ? buildFull() : buildMini();
    job.then(function () { window.location.href = '/cart'; }).catch(function (err) {
      status.textContent = (err && err.message) || 'Something went wrong. Please try again.'; status.classList.add('is-error'); btn.disabled = false;
    });
  }

  function buildFull() {
    var lines = fullLines(), total = lines.reduce(function (s, l) { return s + l.qty; }, 0), mockup = fullNeedsMockup(lines);
    var addons = [], attrs = attrsBase('Full-Size', total, mockup);
    var chain = Promise.resolve();
    lines.forEach(function (l) {
      chain = chain.then(function () {
        var cf = l.cfg, isColl = l.kind === 'collection';
        var variant = D.products[(isColl ? 'col' : 'per') + (l.size === 'small' ? 'Small' : 'Large')];
        var label = isColl ? 'WISH Moments — ' + cf.moment : 'Personalized Jar Candle';
        var hid = cf.hidden && cfgHiddenAllowed(cf, l.kind);
        var props = {};
        if (isColl) props['Moment'] = cf.moment; else { props['Wax Color'] = cf.color; props['Scent'] = cf.scent; }
        props['Decor'] = cf.decor ? 'Yes' : 'No';
        props['Wick Type'] = cf.wick;
        props['Label'] = cf.personalize ? 'Personalized B&W label' : (isColl ? 'Collection Label' : 'Standard WISH label');
        if (cf.personalize) {
          if (cf.labelMode === 'same') props['Label Message'] = cf.labelText.trim(); else props['Label Messages'] = joinLines(cf.labelLines);
          if (cf.notes.trim()) props['Design Notes'] = cf.notes.trim();
        }
        if (hid) { if (cf.hiddenMode === 'same') props['Hidden Message'] = cf.hiddenText.trim(); else props['Hidden Messages'] = joinLines(cf.hiddenLines); }
        props['Gift Packaging'] = cf.gift ? 'Yes' : '';
        // Non-underscored so it shows on the cart, checkout, order status page and order confirmation email
        // (Shopify renders every line-item property that doesn't start with "_"), with no admin template edit needed.
        if (cf.personalize) props['Your Design'] = 'We\u2019ll email your B&W mockup within 1\u20135 business days. Up to 2 revisions included. Production begins after you approve your final design.';
        props['_Bulk Type'] = isColl ? 'Full-Size Collection' : 'Full-Size Personalized';
        props['_Requires Mockup'] = cf.personalize ? 'Yes' : 'No';
        var file = cf.personalize ? (files[FILEPFX[l.kind] + l.idx] || null) : null;
        return postForm(fdFor(variant, l.qty, props, file, 'Design File')).then(function (res) {
          var key = res.key || (res.items && res.items[0] && res.items[0].key);
          var base = { '_Addon For': label, '_Addon Parent Key': key, '_Bulk Type': props['_Bulk Type'] };
          function push(id, name) { addons.push({ id: id, quantity: l.qty, properties: Object.assign({ '_Addon Label': name }, base) }); }
          if (cf.decor) push(D.products.decor, 'Decor');
          if (hid) push(D.products.hidden, 'Hidden Message');
          if (cf.gift) push(D.products.gift, 'Gift Packaging');
        });
      });
    });
    return chain.then(function () { return addons.length ? postJSON('/cart/add.js', { items: addons }) : null; })
      .then(function () { return postJSON('/cart/update.js', { attributes: attrs }); });
  }

  function buildMini() {
    var m = state.mini, total = miniTotal(), mockup = miniPersonalized();
    var attrs = attrsBase('Mini Favors', total, mockup);
    var variant = D.products[m.type === 'tin' ? 'tin' : 'threeD'];
    var chain = Promise.resolve();
    miniLines().forEach(function (c) {
      chain = chain.then(function () {
        var props = {
          'Favor Type': m.type === 'tin' ? '1 oz Tin Favor' : '3D Candle Favor',
          'Shape': m.type === 'threeD' ? shapeName(c.shape) : '',
          'Scented': c.scented === 'yes' ? 'Scented' : 'Unscented',
          'Scent': c.scented === 'yes' ? c.scent : '',
          'Color': c.color,
          'Packaging': packName(c.pack),
          'Gift Packaging': 'Included', 'Wick Type': 'Cotton Wick',
          '_Bulk Type': m.type === 'tin' ? 'Mini Tin' : 'Mini 3D', '_Requires Mockup': mockup ? 'Yes' : 'No'
        };
        if (mockup) {
          props['Personalization'] = 'Yes (B&W)';
          props['Names / Event'] = m.persNames.trim(); props['Date'] = m.persDate.trim(); props['Short Message'] = m.persMessage.trim(); props['Design Notes'] = m.persNotes.trim();
          props['Your Design'] = 'We\u2019ll email your B&W mockup within 1\u20135 business days. Up to 2 revisions included. Production begins after you approve your final design.';
        }
        return postForm(fdFor(variant, num(c.qty), props, mockup ? files.mini : null, 'B&W Photo'));
      });
    });
    return chain.then(function () { return postJSON('/cart/update.js', { attributes: attrs }); });
  }

  /* ---------------- init ---------------- */
  root.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = '+' + money(D.prices[el.getAttribute('data-price')]); });
  renderConfigList('collection');
  renderConfigList('personalized');
  renderMiniList();
  mountExtras();
  update();
})();
